import {createSelector} from 'reselect';

export const eventSelector = (state) => state.event || {};
export const buildYourOrderSelector = (state) => state.buildyourorder || {};
export const querySelector = (state) => state.query || {};
export const currencyExchangeSelector = (state) => state.currencyExchange || {};
export const eventCurrencySelector = createSelector(eventSelector, (event = {}) => event.currencyCode);
export const listingSelector = createSelector(
  buildYourOrderSelector,
  (buildYourOrder = {}) => buildYourOrder.listing || {},
);
export const listingPriceSelector = createSelector(listingSelector, (listing = {}) => listing.price);
export const splitVectorSelector = createSelector(listingSelector, (listing = {}) => listing.splitVector || []);
export const queryDataSelector = createSelector(querySelector, (query = {}) => query.data || {});
export const buildYourOrderQuantitySelector = createSelector(queryDataSelector, (data = {}) => data.byo_qty);
export const advisoryCurrencySelector = createSelector(
  currencyExchangeSelector,
  (currencyExchange = {}) => currencyExchange.selectedCurrency,
);
export const enableQuantityPickerSelector = createSelector(
  splitVectorSelector,
  (splitVector = []) => splitVector.length > 1,
);
export const isPriceLoadingSelector = createSelector(buildYourOrderSelector, (buildYourOrder = {}) =>
  Boolean(buildYourOrder.isPriceLoading),
);
export const byoPriceSelector = createSelector(buildYourOrderSelector, (buildYourOrder = {}) => buildYourOrder.price);
